import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { TRANSCRIPT_ROUTES } from "TranscriptsV3/modules/constants";
import {
  AcademicRecords,
  GradeLevels,
  StudentTranscriptPreview,
} from "./routes";

export default store => ({
  path: `${TRANSCRIPT_ROUTES.STUDENTS}/:studentId`,
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "transcripts-v3-student-details" */ "./components"
    ).then(m => m.default)
  ),
  childRoutes: [
    AcademicRecords(store),
    GradeLevels(store),
    StudentTranscriptPreview(store),
  ],
});
